import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { getJiraSummarySlice } from './summary/get';
import { patchJiraIntegration } from '@api';

export const patchJiraIntegrationSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [ getJiraSummarySlice.asyncActionCreators.requestGetJiraSummary ]
	},
	name: 'jiraIntegration',
	receive: false,
	request: true,
	requestHandler: patchJiraIntegration
});
